export default __webpack_public_path__ + "static/proViotics_in_hand-5778d64cede641b3a42d01d848a19adb.png";